// This component renders each chart/table view in the details view
import React from "react";
import withState from "recompose/withState";
import withProps from "recompose/withProps";
import databaseCache from "Services/databaseCache";
import lifecycle from "recompose/lifecycle";
import compose from "recompose/compose";
import { Nav, NavItem, NavLink, TabPane, TabContent } from "reactstrap";
import humanify from "Utils/humanify";
import classnames from "classnames";
import render from "Utils/template_render";
import Captions from "Captions";
import hasZeroData from "Utils/hasZeroData";
import NoDataMessage from "Components/NoDataMessage";
let createReactClass = require("create-react-class");
import config from "Config";
import { minorGroupCountriesLookup } from "Lookups";
import { minorGroups } from "Data";
// import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2"; // TODO: move it into the config

const DataUnavailable2016 = () =>
  "http://www.abs.gov.au/ausstats/abs@.nsf/Lookup/by%20Subject/2011.0~2016~Main%20Features~Release%20Dates~10016".chain(
    (infoLink) => (
      <div className="p-4">
        <div className="row">
          <div className="col-3">
            <i
              className="fa fa-5x fa-exclamation-triangle"
              aria-hidden="true"
            />
          </div>
          <div className="col-9">
            This data is currently unavailable from the Australian Bureau of
            Statistics. For more information on data release dates see this{" "}
            <b>
              <a rel="noopener" target="_blank" href={infoLink}>
                link
              </a>
            </b>
            .
          </div>
        </div>
      </div>
    )
  );

  const Unreleased2021 = () =>
  "https://www.abs.gov.au/census/2021-census-data-release-plans/2021-census-product-release-guide".chain(
    (Unreleased2021Link) => (
      <div className="p-4">
        <div className="row">
          <div className="col-3">
            <i
              className="fa fa-5x fa-exclamation-triangle"
              aria-hidden="true"
            />
          </div>
          <div className="col-9">
            This data is currently unavailable from the Australian Bureau of
            Statistics. For more information on data release dates see this{" "} 
            <b>
              <a rel="noopener" target="_blank" href={Unreleased2021Link}>
                link
              </a>
            </b>
            .
          </div>
        </div>
      </div>
    )
  );

const DataGone2021 = () =>
  "https://www.abs.gov.au/census/guide-census-data/census-dictionary/2021/whats-new-2021".chain(
    (DataGone2021Link) => (
      <div className="p-4">
        <div className="row">
          <div className="col-3">
            <i
              className="fa fa-5x fa-exclamation-triangle"
              aria-hidden="true"
            />
          </div>
          <div className="col-9">
            The variable informing this page was removed for the 2021 Census. For more information see this{" "}
            <b>
              <a rel="noopener" target="_blank" href={DataGone2021Link}>
                link
              </a>
            </b>
            .
          </div>
        </div>
      </div>
    )
  );

const removeEmptyKeys = (obj) => {
  let _new = {};
  var propNames = Object.getOwnPropertyNames(obj);
  for (var i = 0; i < propNames.length; i++) {
    var propName = propNames[i];
    if (obj[propName] !== null && obj[propName] !== undefined) {
      _new[propName] = obj[propName];
    }
  }
  return _new;
};

const tabsFor = (_components) =>
  removeEmptyKeys(_components).chain((components) => {
    // make sure we only tap if there's more than one
    // child component
    if (Object.values(components).length <= 1) {
      return Object.values(components)[0];
    }
    return createReactClass({
      getInitialState() {
        return {
          key: 1,
        };
      },
      handleSelect(key) {
        this.setState({ key });
      },
      downloadChartImage(e, tab_name) {
        let uri = this.refs[tab_name].chartInstance
          .toBase64Image()
          .replace(/^data:image\/[^;]+/, "data:application/octet-stream");

        document.createElement("a").chain((link) => {
          link.download = `${this.props.data.table.name} ${humanify(
            tab_name
          )}.png`;
          link.href = uri;
          link.click();
          e.preventDefault();
        });
      },
      render() {
        return (
          <div style={{ width: "100%" }}>
            <Nav tabs>
              {Object.keys(components).map((tab_name, index) => (
                <NavItem key={tab_name}>
                  <NavLink
                    className={classnames({
                      active: this.state.key == index + 1,
                    })}
                    onClick={() => {
                      this.handleSelect(index + 1);
                    }}
                  >
                    {humanify(tab_name)}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <TabContent activeTab={this.state.key} onSelect={this.handleSelect}>
              {Object.keys(components).map((tab_name, index) =>
                components[tab_name].chain((Component) => (
                  <TabPane
                    key={index}
                    tabId={index + 1}
                    title={humanify(tab_name)}
                  >
                    {tab_name === "Chart" ||
                    tab_name === "Comparison_with_WA" ? (
                      <button
                        type="button"
                        className="mt-3 mb-3 btn btn-info btn-sm btn-download"
                        onClick={(e) => this.downloadChartImage(e, tab_name)}
                      >
                        <i className="fa fa-download" aria-hidden="true" />{" "}
                        Export Image
                      </button>
                    ) : null}
                    {tab_name === "Comparison_with_WA" ? (
                      <Component
                        data={this.props.comparisonData}
                        options={this.props.comparisonChartOptions}
                        height={this.props.height}
                        ref={"Comparison_with_WA"}
                      />
                    ) : (
                      <Component
                        {...this.props}
                        ref={tab_name === "Chart" ? "Chart" : null}
                      />
                    )}
                  </TabPane>
                ))
              )}
            </TabContent>
          </div>
        );
      },
    });
  });

// TODO: Refactor this madness
// This function takes the diagramData from each of the sections and returns an object containing
// a react component with the caption, chart, table per section. section name is the key mapping to the
// react component for that section.
// {
//   "Age and Gender": <ReactComponent/>,
//   ....
// }
const refreshData = (props) => {
  let { queries, dataPipeline, showFor } = props;

  let all_queries = determineQueriesForDomainData(queries, props);

  // getData last arg is a function that is run when the query resolves
  return databaseCache.getData(
    all_queries,
    {},
    props.domain_data,
    dataPipeline(props.domain_data, showFor)
  );
};

const shouldIRefreshTheData = (domain_data, showFor, props) => {
  let changed = [
    "year",
    "community",
    "community_value",
    "geo_aggregation",
    "geo_aggregation_value",
  ].reduce(
    (memo, key) =>
      domain_data[key] !== props.domain_data[key] ? memo.concat(key) : memo,
    []
  );

  if (
    changed.length == 1 &&
    changed[0] == "community" &&
    props.domain_data.community_value == ""
  ) {
    // prevent refresh if community value hasn't been selected
    return false;
  } else if (changed.length > 0) {
    return true;
  } else {
    return false;
  }
};

const addChartState = withState("chartData", "setChartData", {
  chartData: null,
  captionData: null,
  comparisonData: null,
});
const addLifecycle = lifecycle({
  componentWillUnmount() {
    this.ignore_incomming = true;
  },

  componentDidMount() {
    this.props.setChartData({
      chartData: null,
      captionData: null,
      comparisonData: null,
    });
    refreshData(this.props).then(
      (res) =>
        this.ignore_incomming ||
        this.props.setChartData(newStateObject(res, this.props))
    );
  },
  componentWillReceiveProps({ domain_data, showFor, ...rest }) {
    if (shouldIRefreshTheData(domain_data, showFor, this.props)) {
      this.props.setChartData({ chartData: null, captionData: null });

      refreshData({ domain_data, showFor, ...rest }).then(
        (res) =>
          this.ignore_incomming ||
          this.props.setChartData(newStateObject(res, this.props))
      );
    }
  },
});

const addConfigProps = (props) => withProps(props);

const determineQueriesForDomainData = (
  queries,
  { hasComparison, showFor, domain_data, comparisonQuery }
) => {
  let all_queries;
  if (queries.length > 2) {
    // ATM This is only for "Population Composition"
    // TODO: FIXME: BAD!! Magic number!! :O
    // the two is just by chance as the
    // Summary component has more than 2 queries
    // the rest have only one except
    // Birthplace - this should be made explicit somehow
    //
    // TODO: use props or sub-category value to append queries to
    // dataPipeline but currently we can't since the / url has no
    // match params for the sub-category selected
    all_queries = queries;
    if (showFor === "community") {
      // see: src/components/Charts/KeyStatistics.js
      // for the initial pipeline with these queries
      // which are for showFor="geo_aggregation"
      // but if showFor="community" we convert them
      // here to their community version
      all_queries = queries.map((q) =>
        [
          "TOTAL_POPULATION",
          "CATEGORY_BORN_IN_AU",
          "BIRTHPLACE_NOT_STATED",
          "CATEGORY_INDIGENOUS_STATUS",
          "CATEGORY_BORN_IN_EN_SPEAKING",
          "CATEGORY_AGE_AND_GENDER_TOTAL",
          "CATEGORY_BIRTHPLACE_TOP",
        ].includes(q)
          ? `${q}_COMMUNITY`
          : q
      );
    }
  } else if (
    // for queries that don't have a _STATE or NA query
    ["CATEGORY_SERVICE_AGE"].includes(queries[0])
  ) {
    all_queries =
      showFor == "community" ? [queries[0] + "_COMMUNITY"] : [queries[0]];
  } else if (queries[0] === "CATEGORY_LGA_DISTRIBUTION") {
    all_queries =
      showFor == "community" ? [queries[0] + "_COMMUNITY"] : [queries[0]];

    // for CATEGORY_LGA_DISTRIBUTION add the total population
    all_queries = all_queries.concat(
      showFor == "community"
        ? ["TOTAL_POPULATION_COMMUNITY"]
        : ["TOTAL_POPULATION"]
    );
  } else {
    all_queries = (showFor == "community"
      ? [
          ...queries.map((q) => `${q}_COMMUNITY`),
          `${getQueryNameForCommunityTotalByOriginalQuery(
            queries[0]
          )}_COMMUNITY`,
        ]
      : [...queries, getQueryNameForCommunityTotalByOriginalQuery(queries[0])]
    ).concat(
      // append queries for state and total
      // populations to calculate captions
      // FIXME: refactor is very convoluted
      [
        ...queries.map((q) => `${q}_STATE`),
        getQueryNameForStateTotalByOriginalQuery(queries[0]),
        showFor === "community"
          ? `${queries[0]}_COMMUNITY_NA`
          : `${queries[0]}_NA`,
      ]
    );
  }
  // TODO: make a function of {domain_data, showFor}
  if (hasComparison && hasComparison(domain_data, showFor)) {
    if (showFor === "community") {
      comparisonQuery = comparisonQuery + "_COMMUNITY";
    }
    all_queries = all_queries.concat([comparisonQuery]);
  }
  return all_queries;
};

const getQueryNameForCommunityTotalByOriginalQuery = (originalQuery) => {
  const mapping = {
    CATEGORY_ANCESTRY: "CATEGORY_ANCESTRY_TOTAL",
    CATEGORY_QUALIFICATIONS: "CATEGORY_QUALIFICATIONS_TOTAL",
    CATEGORY_EDUCATION: "CATEGORY_EDUCATION_TOTAL",
    CATEGORY_EMPLOYMENT_STATUS: "CATEGORY_AGE_15_PLUS_TOTAL",
    CATEGORY_OCCUPATION: "CATEGORY_OCCUPATION_TOTAL",
    CATEGORY_VOLUNTARY_WORK: "CATEGORY_AGE_15_PLUS_TOTAL",
    CATEGORY_INCOME: "CATEGORY_AGE_15_PLUS_TOTAL",
    CATEGORY_FAMILY_COMPOSITION: "CATEGORY_FAMILY_COMPOSITION_TOTAL",
    CATEGORY_CHILDREN_IN_FAMILY: "CATEGORY_CHILDREN_IN_FAMILY_TOTAL",
    CATEGORY_RESIDENTS_IN_DWELLING:
      "CATEGORY_PERSONS_IN_PRIVATE_DWELLING_TOTAL",
    CATEGORY_INTERNET_ACCESS: "CATEGORY_PERSONS_IN_PRIVATE_DWELLING_TOTAL",
    CATEGORY_HOUSEHOLD_INCOME: "CATEGORY_PERSONS_IN_PRIVATE_DWELLING_TOTAL",
    CATEGORY_UNPAID_CARE: "CATEGORY_AGE_15_PLUS_TOTAL",
    CATEGORY_PRFCY_ENG: "CATEGORY_PRFCY_ENG_TOTAL",
  };

  return mapping[originalQuery] || "TOTAL_POPULATION";
};

const getQueryNameForStateTotalByOriginalQuery = (originalQuery) => {
  const mapping = {
    CATEGORY_ANCESTRY: "CATEGORY_ANCESTRY_STATE_TOTAL",
    CATEGORY_QUALIFICATIONS: "CATEGORY_QUALIFICATIONS_STATE_TOTAL",
    CATEGORY_EDUCATION: "CATEGORY_EDUCATION_STATE_TOTAL",
    CATEGORY_EMPLOYMENT_STATUS: "CATEGORY_AGE_15_PLUS_STATE_TOTAL",
    CATEGORY_OCCUPATION: "CATEGORY_OCCUPATION_STATE_TOTAL",
    CATEGORY_VOLUNTARY_WORK: "CATEGORY_AGE_15_PLUS_STATE_TOTAL",
    CATEGORY_INCOME: "CATEGORY_AGE_15_PLUS_STATE_TOTAL",
    CATEGORY_FAMILY_COMPOSITION: "CATEGORY_FAMILY_COMPOSITION_STATE_TOTAL",
    CATEGORY_CHILDREN_IN_FAMILY: "CATEGORY_CHILDREN_IN_FAMILY_STATE_TOTAL",
    CATEGORY_RESIDENTS_IN_DWELLING:
      "CATEGORY_PERSONS_IN_PRIVATE_DWELLING_STATE_TOTAL",
    CATEGORY_INTERNET_ACCESS:
      "CATEGORY_PERSONS_IN_PRIVATE_DWELLING_STATE_TOTAL",
    CATEGORY_HOUSEHOLD_INCOME:
      "CATEGORY_PERSONS_IN_PRIVATE_DWELLING_STATE_TOTAL",
    CATEGORY_UNPAID_CARE: "CATEGORY_AGE_15_PLUS_STATE_TOTAL",
    CATEGORY_PRFCY_ENG: "CATEGORY_PRFCY_ENG_STATE_TOTAL",
  };

  return mapping[originalQuery] || "TOTAL_POPULATION_STATE";
};

const newStateObject = (res, { domain_data, captionDataDerive, showFor }) => {
  // TODO make comparison_data camelCase in the datapipeline config
  const comparisonData = res.comparison_data;

  // Check if this is a Minor Group (community view with birthplace aggregation)
  const isMinorGroup = showFor === "community" && 
    domain_data.community && 
    domain_data.community.toLowerCase() === "birthplace" && 
    domain_data.community_value &&
    minorGroups.items.includes(domain_data.community_value);

  // Get Minor Group definition if applicable
  const minorGroupDefinition = isMinorGroup && minorGroupCountriesLookup[domain_data.community_value]
    ? `This region includes: ${minorGroupCountriesLookup[domain_data.community_value].join(", ")}`
    : "";

  return {
    comparisonData,
    chartData: res,
    captionData: {
      ...captionDataDerive(res),
      community_phrase: domain_data.community
        ? render(Captions.communityPhrases[domain_data.community], domain_data)
        : "",
      minor_group_definition: minorGroupDefinition,
    },
  };
};

const Template = ({
  chartData: { chartData, captionData, comparisonData },
  domain_data,
  match,
  hide_table,
  hideFootnote,
  ChartComponent,
  TableComponent,
  chartOptions,
  comparisonChartOptions,
  height,
  footnote,
  captions,
  showFor,
  hasComparison,
  comparisonQuery,
  isInfoPane = false,
  name,
}) =>
  chartData ? (
    // React Component for the section
    <div>
      {captionData.minor_group_definition && name === "Age and Gender" && (
        <div className="alert alert-warning" role="alert" style={{ marginTop: "1rem", marginBottom: "1rem" }}>
          {captionData.minor_group_definition}
        </div>
      )}
      {!hasZeroData(chartData) && match &&
        captions[
          match.params.geo_aggregation || "community"
        ].map((caption, index) => (
          <p key={index}>
            {render(caption, Object.assign({}, domain_data, captionData))}
          </p>
        ))}

      {hasZeroData(chartData) && !isInfoPane ? (
        <NoDataMessage />
      ) : (
        tabsFor({
          Chart: ChartComponent,
          ...(hasComparison && hasComparison(domain_data, showFor)
            ? { Comparison_with_WA: Bar }
            : {}),
          Table: TableComponent,
        }).chain((Component) => (
          <Component
            data={chartData}
            comparisonData={comparisonData}
            height={height}
            options={chartOptions}
            comparisonChartOptions={comparisonChartOptions}
            geo={domain_data.geo_aggregation_value || config.admin_state_name}
            geo_aggregation={domain_data.geo_aggregation}
            year={domain_data.year}
            community={domain_data.community}
            community_value={domain_data.community_value}
            hide_table={hide_table ? hide_table : false}
            hideFootnote={hideFootnote}
            showFor={showFor}
          />
        ))
      )}
      {footnote && !hideFootnote ? (
        <p
          className="mt-4 small text-muted"
          dangerouslySetInnerHTML={{
            __html: render(footnote.join("\n"), domain_data),
          }}
        ></p>
      ) : null}
    </div>
  ) : (
    <span
      style={{ height: "300px" }}
      className="d-flex align-items-center justify-content-center"
    >
      <i className="fa fa-cog fa-spin fa-2x fa-fw" />
      Waiting for data ...
    </span>
  );

export default (diagramData) =>
  Object.keys(diagramData).reduce(
    (memo, key) =>
      Object.assign(memo, {
        [key]: diagramData[key]
          .chain(
            // get diagramConfigData
            ({
              name = key,
              missingFor2016,
              missingFor2021,
              notYetReleasedFor2021,
              ChartComponent,
              TableComponent,
              queries,
              captionDataDerive = (_) => {},
              footnote,
              captions,
              dataPipeline,
              chartOptions = {},
              comparisonChartOptions = {},
              height = 300,
              hasComparison,
              comparisonQuery,
            }) =>
              compose(
                addConfigProps({
                  name,
                  missingFor2016,
                  missingFor2021,
                  notYetReleasedFor2021,
                  ChartComponent,
                  TableComponent,
                  queries,
                  captionDataDerive,
                  footnote,
                  captions,
                  dataPipeline,
                  chartOptions,
                  comparisonChartOptions,
                  height,
                  hasComparison,
                  comparisonQuery,
                }),
                addChartState,
                addLifecycle
              )(Template)
          )
          .chain((DiagramComponent) => ({
            config: ({ domain_data, ...rest }) => {
              return {
                params: { domain_data, ...rest, ...diagramData[key] },
                getData: async () =>
                  refreshData({ domain_data, ...rest, ...diagramData[key] }),
                getNewState: (resp) =>
                  newStateObject(resp, {
                    domain_data,
                    ...rest,
                    ...diagramData[key],
                  }),
              };
            },
            component: ({ domain_data, ...rest }) =>
              (diagramData[key].missingFor2016 && domain_data.year == "2016") ? (
                <DataUnavailable2016 />
              ) :
              (diagramData[key].notYetReleasedFor2021 && domain_data.year == "2021") ? (
                <Unreleased2021 />
              ) :
              (diagramData[key].missingFor2021 && domain_data.year == "2021") ? (
                <DataGone2021 />
              ) : (
                <DiagramComponent {...rest} domain_data={domain_data} />
              ),
          })),
      }),
    {}
  );



// WEBPACK FOOTER //
// ./components/Charts/CaptionTableChartComponent.js